import { LimitsBlockDefault, } from "./LimitsBlockDefault.tsx";
import { LimitsBlockModerator, } from "./LimitsBlockModerator.tsx";
import { useModeratorStore, } from "../../../../../store/moderatorStore.ts";

/**
 * Limit represents the available card limit.
 *
 * This block is responsible for displaying the available limit (Denum or WB)
 * and the header for the main page.
 */
export function LimitsBlock() {
  const isModerator = useModeratorStore(state => state.isModerator,);

  return (
    <>
      {isModerator ? <LimitsBlockModerator /> : <LimitsBlockDefault />}
    </>
  );
}
